import Model from '@/models/Model.js';

export default class VideoActivityTemplate extends Model {
    static entity = 'video_activity_templates';

    static fields() {
        return {
            id: this.attr(null),
            video_id: this.attr(null),
            content: this.attr(null),
            acknowledgment_message: this.attr(null),

            ...super.fields(),

            video: this.belongsTo('videos', 'video_id'),
            activity_template: this.morphOne('activity_templates', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
